var map = {
	"./accept-change.svg": "6fdV",
	"./accept-local.svg": "lNbp",
	"./address-book.svg": "Ws7U",
	"./all-range.svg": "stAt",
	"./arrow-down.svg": "2s8A",
	"./arrow-right.svg": "Y4vM",
	"./arrow-up.svg": "H8uq",
	"./close.svg": "ifZ1",
	"./delete.svg": "sX3F",
	"./foreign-change.svg": "kpDc",
	"./information.svg": "ltjg",
	"./input-delete.svg": "Mm/1",
	"./log.svg": "Xt66",
	"./logged.svg": "V1zU",
	"./login.svg": "12ns",
	"./navigation.svg": "dXjL",
	"./part-range.svg": "IFNH",
	"./qrcode.svg": "Ifab",
	"./refused.svg": "PpYT",
	"./right.svg": "Gns9",
	"./search.svg": "Svqt",
	"./sf-express.svg": "Z7lt",
	"./sf-logo.svg": "P+yu",
	"./special-receive.svg": "jusQ",
	"./three-line.svg": "ciao",
	"./to-left.svg": "qwUb",
	"./to-right.svg": "almc",
	"./vector.svg": "mz5T"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4X3+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ./node_modules/xml-loader ^\.\/.*\.svg$
// module id = 4X3+
// module chunks = 2